import { Checkbox, Col, Form, Input, Row, Select } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";

import DatePicker from "../modalnotification/DatePicker";
import { _formatMoney } from "../utils";
import { AuthContext } from "./../index";
import MdSelect from "./../modalnotification/modalSelect";
import BackButton from "./backButton";
import ViewPDF from "./viewPDFinternal";

import DKPDF from "../assets/quy-tac-bao-hiem.pdf";
import ChinhSach from "../assets/chinh-sach.pdf";
import Icmnd from "../assets/icmnd.svg";
import Idiachi from "../assets/idiachi.svg";
import Iphone from "../assets/idienthoai.svg";
import Iemail from "../assets/iemail.svg";
import Ihoten from "../assets/ihoten.svg";
import Ithoigian from "../assets/ithoigian.svg";

const Insuinfomation = () => {
  const { goStep, ArrPackage, dataIsu, SetDataIsu } = useContext(AuthContext);
  const { Option } = Select;
  const [form] = Form.useForm();
  const formRef = React.createRef();

  const [datePickerDob, setDatePickerDob] = useState({});
  const [formData, setFormData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [err, setErr] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [isOpenChinhSach, setisOpenChinhSach] = useState(false);



  useEffect(() => {
    window.scrollTo(0, 0);
    if (dataIsu) {
      form.setFieldsValue(dataIsu);
      setFormData(dataIsu);
    }
  }, []);

  useEffect(() => {
    if (dataIsu) {
      form.setFieldsValue(dataIsu || {});
    }
  }, [dataIsu]);

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        SetDataIsu(values);
        goStep(4);
      })
      .catch((err) => {
        // console.error('err:', err);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  useEffect(() => {
    valiDateInput();
  }, [formData]);

  const valiDateInput = () => {
    var insuredName = formData.insuredName ? true : false;
    var insuredDob = formData.insuredDob ? true : false;
    var insuredPrivateId = formData.insuredPrivateId;
    var reSDT = /((09|03|07|08|05)+([0-9]{8})\b)/.test(formData.buyerPhone);
    var reCMND = /^[A-Z][0-9]{7}$|^[0-9]{9}$|^[0-9]{12}$/.test(
      formData.insuredPrivateId
    );
    var reEmail = /\S+@\S+\.\S+/.test(formData.buyerEmail);
    var buyerAddress = formData.buyerAddress;
    if (formData?.rules) {
      var rules = formData?.rules[0] === "rules" ? true : false;
    }
    if (formData?.rules2) {
      var rules2 = formData?.rules2[0] === "rules2" ? true : false;
    }
    var packages = formData.package;
    if (
      reEmail &&
      reCMND &&
      insuredPrivateId &&
      reSDT &&
      insuredName &&
      insuredDob &&
      packages &&
      rules &&
      rules2
    ) {
      setErr(true);
    } else {
      setErr(false);
    }
  };

  return (
    <div style={{ fontSize: 14, background: "#EDEFFA" }}>
      <ViewPDF
        title={"Điều kiện, điều khoản"}
        isOpen={isOpen}
        url="https://cdn.globalcare.vn/private/pdf/tomato/bhv-rule/quy-tac-tai-nan.pdf"
        onClose={() => setisOpen(!isOpen)}
      />
      <ViewPDF
        title={"Chính sách"}
        isOpen={isOpenChinhSach}
        url="https://cdn.globalcare.vn/private/document/pdf/globalcare/2024-GC-CHINH-SACH-PHONG-CHONG-GIAN-LAN-THAM-NHUNG.pdf"
        onClose={() => setisOpenChinhSach(!isOpenChinhSach)}
      />
      <MdSelect
        form={form}
        data={formData?.listPackageInsu}
        handleCancel={handleCancel}
        isModalVisible={isModalVisible}
      />

      <DatePicker
        onConfirm={(data) => {
          form.setFieldsValue({ insuredDob: data });
          onChangForm({ data, name: "insuredDob" });
        }}
        max={moment().subtract(15, "d").toDate()}
        min={moment().subtract(70, "y").add(1, "days").toDate()}
        visible={datePickerDob.open}
        close={() => {
          setDatePickerDob({ ...datePickerDob, open: false });
        }}
        value={formData.insuredDob}
      />
      <Form ref={formRef} form={form} onFinish={onFinish} name="dataIsu">
        <Row>
          <Col
            style={{ borderBottom: "1px solid #009B4B", background: "#ffffff" }}
            xs={24}
          >
            <div
              onClick={valiDateInput}
              style={{ fontWeight: 600, padding: "2% 3%", fontSize: 17 }}
            >
              Thông tin người được bảo hiểm
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3% 0px 3%", position: "relative" }}>
              <div style={css.titleInput}>
                Họ và tên<span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
              <Form.Item
                name="insuredName"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={{ ...css.input, textTransform: "capitalize" }}
                  placeholder="Nhập họ và tên"
                  onChange={(e) =>
                    onChangForm({ data: e.target.value, name: "insuredName" })
                  }
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3% 0px 3%", position: "relative" }}>
              <div>
                <div style={{ position: "relative" }}>
                  <div style={css.titleInput}>
                    Ngày sinh <span style={{ color: "red" }}>*</span>
                  </div>
                  <img style={css.iconInput} src={Ithoigian} alt="quyen loi" />
                  <Form.Item
                    name="insuredDob"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn và nhập thông tin",
                      },
                    ]}
                    style={css.FormItemsHolder}
                  >
                    <Input
                      autoComplete="off"
                      readOnly
                      style={{ ...css.input, paddingRight: "6px" }}
                      placeholder="DD/MM/YYYY"
                      onClick={() => {
                        setDatePickerDob({ ...datePickerDob, open: true });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3% 0px 3%", position: "relative" }}>
              <div style={css.titleInput}>
                Số điện thoại<span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Iphone} alt="điện thoại" />
              <Form.Item
                name="buyerPhone"
                rules={[
                  {
                    required: true,
                    message:
                      "Vui lòng nhập SĐT định dạng số, không bao gồm ký tự đặc biệt.",
                    pattern: /((09|03|07|08|05)+([0-9]{8})\b)/,
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={css.input}
                  placeholder="Nhập số điện thoại"
                  type="tel"
                  onChange={(e) =>
                    onChangForm({ data: e.target.value, name: "buyerPhone" })
                  }
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3% 0px 3%", position: "relative" }}>
              <div style={css.titleInput}>
                CMND/ CCCD/ Số định danh<span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Icmnd} alt="cmnd" />
              <Form.Item
                name="insuredPrivateId"
                rules={[
                  {
                    required: true,
                    message:
                      "Vui lòng nhập CMND/CCCD 9 số hoặc 12 số, không bao gồm ký tự đặc biệt.",
                    pattern: /^[A-Z][0-9]{7}$|^[0-9]{9}$|^[0-9]{12}$/,
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  onChange={(e) => {
                    onChangForm({
                      data: e.target.value,
                      name: "insuredPrivateId",
                    });
                  }}
                  style={css.input}
                  placeholder="Nhập CMND, CCCD hoặc Số định danh"
                />
              </Form.Item>
              <div style={{ fontSize: 12, color: "#9A9A9A" }}>
                <i>Trẻ em dưới 18 tuổi nhập số định danh</i>
              </div>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3% 0px 3%", position: "relative" }}>
              <div style={css.titleInput}>
                Email<span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Iemail} alt="email" />
              <Form.Item
                name="buyerEmail"
                rules={[
                  {
                    required: true,
                    message: "Email không hợp lệ",
                    pattern: /\S+@\S+\.\S+/,
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={css.input}
                  placeholder="Nhập Email"
                  onChange={(e) => {
                    onChangForm({ data: e.target.value, name: "buyerEmail" });
                  }}
                />
              </Form.Item>
              <div style={{ fontSize: 12, color: "#9A9A9A" }}>
                <i>Nhập Email để nhận giấy chứng nhận và hoá đơn VAT</i>
              </div>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3% 0px 3%", position: "relative" }}>
              <div style={css.titleInput}>Địa chỉ liên hệ</div>
              <img style={css.iconInput} src={Idiachi} alt="địa chỉ" />
              <Form.Item
                name="buyerAddress"
                rules={[
                  {
                    required: false,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={css.input}
                  placeholder="Nhập địa chỉ liên hệ"
                  onChange={(e) => {
                    onChangForm({ data: e.target.value, name: "buyerAddress" });
                  }}
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3%" }}>
              <div style={{ fontWeight: 500, fontSize: 15 }}>
                Chọn gói bảo hiểm
              </div>
              <Form.Item
                name="package"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                re
                style={css.FormItemsHolder}
              >
                <Select
                  className="custom-select-antd-no-padding-disa"
                  disabled
                  autoComplete="off"
                  onClick={() => setIsModalVisible(true)}
                  placeholder="Chọn gói bảo hiểm"
                >
                  {(ArrPackage || []).map((data, i) => (
                    <Option key={data.id} value={data.id}>
                      {data.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div
              style={{
                fontSize: 15,
                fontWeight: 500,
                padding: "0px 3% 2% 3%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Thời hạn bảo hiểm</span>
              <span>1 năm</span>
            </div>
          </Col>

          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "2% 3%" }}>
              <style>{`
                .consent-link {
                  color: #0044CC !important;
                  text-decoration: none !important;
                  font-weight: 400 !important;
                }
                .consent-link:hover {
                  color: #0033AA !important;
                }
              `}</style>
              <Form.Item
                name="rules"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng đồng ý điều kiện, điều khoản.",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Checkbox.Group
                  disabled={isOpen}
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    onChangForm({ data: e, name: "rules" });
                  }}
                >
                  <Checkbox value="rules">
                    <div style={{ color: "#646D69", fontWeight: 400 }}>
                      Tôi xác nhận thông tin kê khai là trung thực, đầy đủ; đã
                      đọc và đồng ý với{" "}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setisOpen(!isOpen);
                        }}
                        className="consent-link"
                        style={{ cursor: "pointer" }}
                      >
                        Quy tắc & Điều khoản sản phẩm bảo hiểm
                      </span>;{" "} đồng ý để Global Care và các đơn vị liên quan (cổng thanh toán, doanh nghiệp bảo hiểm) chia sẻ, sử dụng thông tin nhằm phát hành, quản lý hợp đồng, tư vấn và hỗ trợ dịch vụ.
                    </div>
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "0% 3%" }}>
              <Form.Item
                name="rules2"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng đồng ý xác nhận thông tin.",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Checkbox.Group
                  disabled={isOpen}
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    onChangForm({ data: e, name: "rules2" });
                  }}
                >
                  <Checkbox value="rules2">
                    <div style={{ color: "#646D69", fontWeight: 400 }}>
                      Tôi xác nhận{" "}
                      <span style={{ fontWeight: 600 }}>
                        là người được bảo hiểm hoặc đã được người được bảo hiểm ủy quyền hợp pháp
                      </span>{' '}
                      thực hiện giao dịch, và chịu trách nhiệm về tính chính xác của thông tin cũng như mọi khiếu nại liên quan.
                    </div>
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: "#ffffff" }} xs={24}>
            <div style={{ padding: "0% 3% 2% 3%", color: '#BF272D', fontSize: 12, textAlign: 'left', fontWeight: 400 }}>
              Lưu ý: Khi chọn vào mục này, đồng nghĩa việc kê khai bảo hiểm đã xong và quý khách không thể cập nhật lại.
            </div>
          </Col>
          <div
            style={{
              borderRadius: "16px 16px 0px 0px",
              justifyContent: "center",
              padding: "16px",
              boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.1)",
              position: "sticky",
              bottom: 0,
              width: "100%",
              background: "#ffffff",
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <div>Tổng tiền thanh toán</div>
              <div>
                <span
                  style={{ fontWeight: 600, color: "#009B4B", fontSize: 19 }}
                >
                  {_formatMoney(ArrPackage[dataIsu?.package - 1]?.fees)}
                </span>
                <span style={{ color: "#9A9A9A", fontSize: 14 }}> VNĐ</span>
              </div>
            </div>
            <BackButton
              onNext={() => {
                if (err) {
                  onFinish();
                }
              }}
              onBack={() => goStep(2)}
              total={true}
              disabled={!err}
            />
          </div>
        </Row>
      </Form>
    </div>
  );
};

export default Insuinfomation;

const css = {
  input: {
    color: "#3A3A3A",
    zIndex: 1,
    fontSize: 15,
    boxShadow: "none",
    padding: "10px 35px",
    borderRadius: 9,
    width: "100%",
  },
  titleInput: { color: "#646D69", marginBottom: 3 },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  iconInput: {
    width: 20,
    margin: "15px 10px",
    position: "absolute",
    zIndex: 2,
    pointerEvents: "none",
  },
};
